var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "html-table-container" }, [
    _vm.tableData.name
      ? _c("div", { staticClass: "table-name-container" }, [
          _c("h2", { staticClass: "table-name" }, [
            _vm._v(_vm._s(_vm.tableData.name)),
          ]),
        ])
      : _vm._e(),
    _c("table", { class: `table-${_vm.tableData.name}` }, [
      _c("thead", [
        _c(
          "tr",
          { staticClass: "table-head-row" },
          _vm._l(_vm.tableData.headers, function (header) {
            return _c(
              "th",
              {
                class: [
                  "head-item",
                  { "button-col": header.type === _vm.ItemTypeEnum.BUTTON },
                ],
              },
              [_vm._v(_vm._s(header.title))]
            )
          }),
          0
        ),
      ]),
      _c(
        "tbody",
        [
          _vm._l(_vm.tableData.items, function (item, itemIndex) {
            return _c(
              "tr",
              {
                key: `${itemIndex}-item`,
                class: ["body-row", { "disabled-item": item.disabled }],
              },
              _vm._l(_vm.tableData.headers, function (header, headerIndex) {
                return _c(
                  "td",
                  {
                    key: `${headerIndex}-header`,
                    class: ["body-item", header.type],
                  },
                  [
                    header.type === _vm.ItemTypeEnum.STRING ||
                    header.type === _vm.ItemTypeEnum.CURRENCY
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              item.disabled && headerIndex !== 0
                                ? ""
                                : item[header.key]
                            )
                          ),
                        ])
                      : _vm._e(),
                    header.type === _vm.ItemTypeEnum.BUTTON &&
                    item.buttons === true
                      ? _c("span", [
                          _c(
                            "button",
                            {
                              attrs: {
                                title: _vm.buttonText
                                  ? _vm.buttonText
                                  : undefined,
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.buttonCallback(item)
                                },
                              },
                            },
                            [_c("span", { class: [_vm.buttonIcon, "icon"] })]
                          ),
                        ])
                      : _vm._e(),
                  ]
                )
              }),
              0
            )
          }),
          _vm.tableData.summary
            ? _c(
                "tr",
                { staticClass: "summary-row" },
                [
                  _c("td", { staticClass: "total-cell" }, [
                    _vm._v(_vm._s(this.totalText)),
                  ]),
                  _vm._l(_vm.parsedSummary, function (summary, summaryIndex) {
                    return _c("td", { staticClass: "summary-item" }, [
                      _c("span", [_vm._v(_vm._s(summary.value))]),
                    ])
                  }),
                ],
                2
              )
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }